/* eslint-disable import/prefer-default-export */
import axios from 'axios'

export const getPortList = payload => axios.get('/shipment-schedule/get-ports' + '?name=' + payload)
  .then(res => res)
  .catch((err) => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getAvailableLines = payload => axios.get('/shipment-schedule/get-available-lines')
  .then(res => res)
  .catch((err) => {
    console.log('err', err, err.response)
    throw err.response
  })

export const getVesselSchedule = ({ sealine, portcode, portdestinationcode, fromdate, weeksahead, direction }) => axios.get(`/shipment-schedule?sealine=${sealine}&portcode=${portcode}&portdestinationcode=${portdestinationcode}&fromdate=${fromdate}&weeksahead=${weeksahead}&direction=${direction}`)
  .then(res => res)
  .catch((err) => {
    console.log('err', err, err.response)
    throw err.response
  })

export const sendRequestQuota = () => axios.get(`/shipment-schedule/request-quota`)
  .then(res => res)
  .catch((err) => {
    console.log('err', err, err.response)
    throw err.response
  })



// WEBPACK FOOTER //
// ./src/api/vessel-schedule.api.js